import { Pipe, PipeTransform } from '@angular/core';
import { BaseParameterType } from '@shared/api/model/base-parameter-type';
import { AppMediumDatePipe } from './app-medium-date.pipe';
import { PropertyType } from '@shared/api/solver/model/property-type';

@Pipe({
  name: 'valueByType',
  standalone: true,
})
export class ValueStringByTypePipe implements PipeTransform {

  transform(value: any, type?: BaseParameterType | PropertyType | null): string {
    if (!value && value !== 0) {
      return '';
    }

    switch(type) {
      case "Boolean":
        return value === true ? $localize `Yes` : $localize `No`;
      case "DateTime":
        return AppMediumDatePipe.transformDate(value);
      case "Decimal":
      case "Integer":
        return `${value}`;
      default:
        return value;
    }
  }

}
